import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/system";

export function FadeTransition({ children, duration = 300 }) {
  const [childState, setChildState] = useState(children);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    if (ref.current && children && !Object.is(childState, children)) {
      const animation = ref.current.animate(
        [{ opacity: "0", visibility: "hidden" }],
        {
          duration: duration / 2,
          iterations: 1,
          fill: "forwards",
        }
      );

      animation.onfinish = () => {
        setChildState(children);
        ref.current.animate([{ opacity: "100%", visibility: "visible" }], {
          duration: duration / 2,
          iterations: 1,
          fill: "forwards",
        });
      };
    }
  }, [children]);

  return <Box ref={ref}>{childState}</Box>;
}
